/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
if (window.innerWidth < 768) {
document.addEventListener('DOMContentLoaded', function() {
  var announcement = document.querySelector('section[data-section-type="announcement-bar"]');
  var input        = document.getElementById('search-input');
  var closeBtns    = document.querySelectorAll('[data-action="unfix-search"]');

  if (!announcement || !input) return;

  // 1) Quand on clique ou focus dans le champ, on cache l'annonce
  input.addEventListener('focus', hideAnnouncement);
  input.addEventListener('click', hideAnnouncement);

  function hideAnnouncement() {
    announcement.style.display = 'none';
  }

  // 2) Quand on clique sur la croix, on la ré-affiche
  closeBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      announcement.style.display = '';
    });
  });
});
  }
document.addEventListener('DOMContentLoaded', adjustDesktopOffset);
window.addEventListener('resize', adjustDesktopOffset);

function adjustDesktopOffset() {
  var main = document.getElementById('main');
  if (!main) return;

  // Vérifie la largeur : seulement desktop
  if (window.innerWidth >= 1024) {
    // Sélectionne le header
    var hdr = document.querySelector('header.header');
    var hdrH = hdr ? hdr.offsetHeight : 0;

    // Applique exactement la hauteur du header
    main.style.marginTop = '30px';
  } else {
    // Sur mobile, aucun margin-top
    main.style.marginTop = '30px';
  }
}